import React, { useRef } from 'react';
import { Button } from '@fcpartners/uikit-v2/components/ui/button';
import { Shutter } from '@monorepo/common';
import Documents from './components/Documents';
import { FileText } from 'lucide-react';
import { cn } from '@spilca/uikit-v2/lib/utils';

type Handler = {
  setIsShow: (val: boolean) => void;
  multiDealId: number;
  isAddDisabled: boolean;
  isDeleteDisabled: boolean;
};

const DealDocuments: Component<Handler> = ({
  multiDealId,
  isAddDisabled,
  isDeleteDisabled
}) => {
  const ref = useRef<Handler>(null);

  const handleOpen = () => {
    if (ref.current) {
      ref.current.setIsShow(true);
    }
  };

  return (
    <>
      <Button
        variant="outline"
        size="icon"
        onClick={handleOpen}
        className="w-9 h-9 transition-all flex items-center justify-center group"
      >
        <FileText
          className={cn(
            'h-4 w-4 transition-transform duration-200'
          )}
        />
      </Button>
      {/* @ts-ignore */}
      <Shutter side="right" ref={ref}>
        <Documents
          multiDealId={multiDealId}
          isAddDisabled={isAddDisabled}
          isDeleteDisabled={isDeleteDisabled}
        />
      </Shutter>
    </>
  );
};

export default DealDocuments;
